export default (timeInMilliseconds) => {
  let hasElapsed = false;
  setTimeout(() => { hasElapsed = true; }, timeInMilliseconds);
  return () => hasElapsed;
};
